//bao migrate skip
import "./badge2.css";
import * as ko from "knockout";
import * as $ from "jquery";
import Bao from "./../../services/bao-service";
export class Badge2ComponentParams {
    /** property-Name for Display Text of the items
    */
    optionsText: string;
    /** Items observable for the item-list, this can be edited from outside (push new items, remove existing, edit existing)
    */
    items: KnockoutObservableArray<any> | Array<any>;
    /** optional - default is this.optionsText - property-Name for PrimaryKey to compare the items,
    */
    optionsPrimaryKey?: string;
    /** optional - property-Name for the boolean-Property to set the Badge's class: "alert-success"
    */
    optionsCss?: KnockoutObservable<string> | string;
    /** optional - subscribe for the Selection
    */
    itemSelected?: (newVal: any) => void;
    /** optional - overrides Badge2Component.deleteItem,
     * @returns true if item was removed successfully, false otherwise
     */
    deleteItem?: (item: any, event: any) => boolean;
    /** optional - overrides Badge2Component.deleteAll
    */
    deleteAll?: (module: Badge2Component, vm: any, event: any) => void;
    /** optional - default false
    */
    ReadOnly?: KnockoutObservable<boolean> | boolean;
    /** optional - default false - enables selection-mode
    */
    UseSelection?: KnockoutObservable<boolean> | boolean;
    /** optional - will be invoked, if an item was removed.
     * @param removedItem: any, the removed item
     */
    EventItemRemoved?: (removedItem: any) => void;
}
export class Badge2Component {
    ReadOnly = ko.observable(false);
    ShowAll = ko.observable(false);
    Selection = ko.observable(null);
    UseSelection = ko.observable(false);
    Items: KnockoutObservableArray<any> = ko.observableArray();
    optionsText: string = '';
    optionsCss: string = '';
    optionsPrimaryKey: string = null;
    itemSelected = (newVal: any) => { };
    Bao = Bao;
    removeAllCustom: any = null;
    removeItemCustom: any = null;
    EventItemRemoved: (item: any) => void = function () { };
    _subs: KnockoutSubscription[] = [];
    constructor(params: Badge2ComponentParams, componentElement: HTMLElement) {
        // check & set MANDATORY params
        if (!params) {
            throw new Error('Params are not set');
        }
        if (params.optionsText) {
            this.optionsText = ko.unwrap(params.optionsText);
        }
        else {
            throw new Error('Param.optionsText is not set');
        }
        // set optional params
        if (params.items) {
            if (ko.isObservable(params.items)) {
                this.Items = params.items;
            }
            else {
                this.Items(params.items);
            }
        }
        if (params.optionsCss) {
            this.optionsCss = ko.unwrap(params.optionsCss);
        }
        if ($.isFunction(params.itemSelected)) {
            this.itemSelected = params.itemSelected;
        }
        if ($.isFunction(params.deleteItem)) {
            this.removeItemCustom = params.deleteItem;
        }
        if ($.isFunction(params.deleteAll)) {
            this.removeAllCustom = params.deleteAll;
        }
        if (params.ReadOnly != undefined) {
            if (ko.isObservable(params.ReadOnly)) {
                this.ReadOnly = params.ReadOnly;
            }
            else {
                this.ReadOnly(params.ReadOnly);
            }
        }
        if (params.UseSelection != undefined) {
            if (ko.isObservable(params.UseSelection)) {
                this.UseSelection = params.UseSelection;
            }
            else {
                this.UseSelection(params.UseSelection);
            }
        }
        if (params.optionsPrimaryKey) {
            this.optionsPrimaryKey = ko.unwrap(params.optionsPrimaryKey);
        }
        else {
            this.optionsPrimaryKey = this.optionsText;
        }
        if ($.isFunction(params.EventItemRemoved)) {
            this.EventItemRemoved = params.EventItemRemoved;
        }
        if ($.isFunction(this.itemSelected)) {
            this._subs.push(this.Selection.subscribe(this.itemSelected));
        }
        // initialize Items.Badged
        this.Items["Badged"] = ko.computed(() => {
            var items = this.Items();
            if (this.ShowAll()) {
                return items;
            }
            else {
                return items.slice(0, 9);
            }
        });
    }
    private CompareItems(a, b) {
        return (a[this.optionsPrimaryKey] === b[this.optionsPrimaryKey]);
    }
    /**
     * Selects the given item, this.UseSelection must be true
     * @param item
     * @param event
     */
    private setSelection = (item, event) => {
        if (this.UseSelection()) {
            if (this.Selection() !== item) {
                this.Selection(item);
            }
            else {
                this.Selection(null);
            }
        }
    };
    public setShowAll = () => {
        this.ShowAll(!this.ShowAll.peek());
    };
    /**
     * Can be overwritten by this.removeAllCustom
     * @param vm
     * @param event
     */
    public removeAll = (vm, event) => {
        if ($.isFunction(this.removeAllCustom)) {
            this.removeAllCustom(this, vm, event);
            return;
        }
        var items = this.Items(), index = 0;
        while (items.length > index) {
            let success = false;
            if (items[index] !== null || typeof items[index] !== "undefined") {
                success = this.removeItem(items[index], event);
            }
            if (success === false) {
                index++;
            }
        }
    };
    /**
     * Can be overwritten by setting this.removeItemCustom
     * @param item if item is an object, it must be the same Instance to match and remove from items
     * @param event
     * @returns true if item was removed successfully, false otherwise
     */
    private removeItem = (item, event) => {
        event.stopPropagation();
        let removeSuccess = false;
        if ($.isFunction(this.removeItemCustom)) {
            removeSuccess = this.removeItemCustom(item, event);
        }
        else {
            let removedItems = this.Items.remove((element) => { return this.CompareItems(element, item); });
            if (removedItems.length > 0) {
                removeSuccess = true;
            }
        }
        if (removeSuccess) {
            this.EventItemRemoved(item);
        }
        return removeSuccess;
    };
    public dispose() {
        this._subs.forEach((sub) => {
            sub.dispose();
        });
    }
}
;